import React, { useState } from "react";

export default function AddWidgetModal({ category, allCategories, onAdd, onRemove, onClose }) {
  const [activeTab, setActiveTab] = useState(category.id);
  const [search, setSearch] = useState("");
  const [newName, setNewName] = useState("");
  const [newText, setNewText] = useState("");

  const allWidgets = allCategories.flatMap((cat) =>
    cat.widgets.map((w) => ({ ...w, categoryId: cat.id, categoryName: cat.name }))
  );

  const filteredWidgets = search
    ? allWidgets.filter((w) =>
        w.name.toLowerCase().includes(search.toLowerCase())
      )
    : null;

  const activeCategory = allCategories.find((c) => c.id === activeTab);

  const handleCheckboxChange = (widget, checked) => {
    if (!checked) onRemove(widget.categoryId, widget.id);
  };

  const handleAddNew = () => {
    if (!newName.trim()) return;
    onAdd(activeTab, newName.trim(), newText.trim());
    setNewName("");
    setNewText("");
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <div className="modal-title-group">
            <h3>Add Widget</h3>
            <span className="modal-badge">{allWidgets.length} available</span>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <p className="modal-subtitle">Personalise your dashboard by adding or removing widgets</p>

        {/* Search */}
        <div className="modal-search-wrap">
          <span className="modal-search-icon">🔍</span>
          <input
            className="modal-search"
            placeholder="Search widgets..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          {search && <button className="modal-search-clear" onClick={() => setSearch("")}>✕</button>}
        </div>

        {search ? (
          <div className="modal-search-results">
            {filteredWidgets.length === 0 ? (
              <div className="no-results">
                <span>🔎</span>
                <p>No widgets found for "{search}"</p>
              </div>
            ) : (
              filteredWidgets.map((w) => (
                <label key={w.id} className="widget-check-row">
                  <input
                    type="checkbox"
                    defaultChecked
                    onChange={(e) => handleCheckboxChange(w, e.target.checked)}
                  />
                  <div className="check-row-info">
                    <span className="check-row-name">{w.name}</span>
                    <span className="widget-cat-badge">{w.categoryName}</span>
                  </div>
                </label>
              ))
            )}
          </div>
        ) : (
          <>
            {/* Category Tabs */}
            <div className="modal-tabs">
              {allCategories.map((cat) => (
                <button
                  key={cat.id}
                  className={`modal-tab ${activeTab === cat.id ? "active" : ""}`}
                  onClick={() => setActiveTab(cat.id)}
                >
                  {cat.name.split(" ")[0]}
                </button>
              ))}
            </div>

            {/* Existing Widgets Checklist */}
            <div className="modal-widget-list">
              {activeCategory?.widgets.length === 0 ? (
                <div className="no-results">
                  <span>📋</span>
                  <p>No widgets in this category yet.</p>
                </div>
              ) : (
                activeCategory?.widgets.map((w) => (
                  <label key={w.id} className="widget-check-row">
                    <input
                      type="checkbox"
                      defaultChecked
                      onChange={(e) => {
                        if (!e.target.checked) onRemove(activeTab, w.id);
                      }}
                    />
                    <div className="check-row-info">
                      <span className="check-row-name">{w.name}</span>
                    </div>
                  </label>
                ))
              )}
            </div>

            {/* Add New Widget Form */}
            <div className="modal-add-form">
              <p className="add-form-label">✦ Create new widget</p>
              <input
                className="add-form-input"
                placeholder="Widget Name *"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
              />
              <input
                className="add-form-input"
                placeholder="Widget Description (optional)"
                value={newText}
                onChange={(e) => setNewText(e.target.value)}
              />
            </div>
          </>
        )}

        {/* Footer Buttons */}
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Cancel</button>
          {!search && (
            <button
              className="btn-confirm"
              onClick={handleAddNew}
              disabled={!newName.trim()}
            >
              + Add Widget
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
